// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3Vi80","inputDescription":"styles_inputDescription__HJ9hb"};